<ul>
	<li *ngFor="let step of steps; let i = index" [class.current]="currentStep === i" [class.completed]="i < currentStep" (click)="goToStep(i)">
		<span class="dot dot--{{ steps.length }}">
			<i class="icon-checkmark"></i>
		</span>
		<p>{{ step }}</p>
	</li>
</ul>
